import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/filterIcon_Disabled.svg'
import _imports_1 from '@/assets/filter.svg'
import _imports_2 from '@/assets/cancel.svg'


const _hoisted_1 = { class: "pt-3 pl-5 pr-5 page-fill" }
const _hoisted_2 = {
  class: "row w-full justify-between flex",
  style: {"align-items":"center"}
}
const _hoisted_3 = { class: "flex items-center gap-3" }
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  class: "filterIcon"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  class: "filterIcon"
}
const _hoisted_6 = { class: "mt-5 table-section" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "flex items-center justify-between popupheadingcontainer rounded" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex flex-col h-full" }
const _hoisted_12 = { class: "flex-1 overflow-auto" }
const _hoisted_13 = { class: "statuscontainer popupbodycontainer" }
const _hoisted_14 = { class: "formcontainer flex flex-col" }
const _hoisted_15 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_16 = { class: "w-full" }
const _hoisted_17 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_18 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_19 = {
  key: 1,
  class: "error-text text-xs"
}
const _hoisted_20 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_21 = { class: "row flex flex-row w-full" }
const _hoisted_22 = { class: "w-6/12" }
const _hoisted_23 = {
  key: 0,
  disabled: "",
  class: "mt-2 text-sm inputboxstyling disiableState"
}
const _hoisted_24 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_25 = {
  key: 0,
  class: "error-text"
}
const _hoisted_26 = { class: "w-3/6 leftspacing" }
const _hoisted_27 = {
  key: 0,
  disabled: "",
  class: "mt-2 text-sm inputboxstyling disiableState"
}
const _hoisted_28 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_29 = {
  key: 0,
  class: "error-text"
}
const _hoisted_30 = { class: "formcontainer flex flex-col upperspacing" }
const _hoisted_31 = { class: "row flex flex-row w-full" }
const _hoisted_32 = { class: "w-6/12" }
const _hoisted_33 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_34 = {
  key: 0,
  class: "error-text"
}
const _hoisted_35 = { class: "w-3/6 leftspacing" }
const _hoisted_36 = ["min"]
const _hoisted_37 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_38 = {
  key: 0,
  class: "error-text"
}
const _hoisted_39 = { class: "row flex flex-row w-full upperspacing" }
const _hoisted_40 = { class: "w-full" }
const _hoisted_41 = {
  key: 0,
  class: "text-red-500"
}
const _hoisted_42 = {
  key: 0,
  class: "error-text text-xs"
}
const _hoisted_43 = { class: "buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5" }
const _hoisted_44 = ["disabled"]
const _hoisted_45 = ["disabled"]
const _hoisted_46 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tableData = _resolveComponent("tableData")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_Select = _resolveComponent("Select")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_popup = _resolveComponent("popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[17] || (_cache[17] = _createElementVNode("h1", { class: "title" }, "Objectives", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "btnprimary flex items-center",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addBtnObjective()))
        }, " Add "),
        _createElementVNode("button", {
          class: _normalizeClass(["flex", _ctx.columnObject ? 'filterButtondisabled pointer-events-none' : 'filterButton']),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.filterOpen && _ctx.filterOpen(...args)))
        }, [
          (_ctx.columnObject)
            ? (_openBlock(), _createElementBlock("img", _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_5)),
          _cache[16] || (_cache[16] = _createTextVNode(" Filters "))
        ], 2)
      ])
    ]),
    _cache[28] || (_cache[28] = _createElementVNode("div", { class: "text-xs mt-3" }, " Define and manage your organization’s information security objectives, and map relevant security controls to each objective. It helps ensure alignment between your security goals and the controls implemented to achieve them. ", -1)),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_tableData, {
        class: "flex-1 min-h-0",
        tableRowData: _ctx.tableRow,
        headersData: _ctx.headers,
        loadData: _ctx.dataLoading
      }, null, 8, ["tableRowData", "headersData", "loadData"]),
      (_ctx.toolTipActive)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(_component_tool_tip, { tipText: _ctx.toolTipText }, null, 8, ["tipText"])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.showPopup)
      ? (_openBlock(), _createBlock(_component_popup, {
          key: 0,
          popUp: _ctx.showPopup
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.createObjective._id)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_9, "Update Objective"))
                : (_openBlock(), _createElementBlock("h1", _hoisted_10, "Create Objective")),
              _createElementVNode("button", {
                class: "float-right text-3xl",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (
              _ctx.onCancelbtn('cross')
            ))
              }, _cache[18] || (_cache[18] = [
                _createElementVNode("img", {
                  src: _imports_2,
                  class: "h-5 w-5 cursor-pointer"
                }, null, -1)
              ]))
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("fieldset", null, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[19] || (_cache[19] = _createElementVNode("label", { class: "controllabel" }, "Objective", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                type: "text-area",
                                class: _normalizeClass(["inputboxstyling mt-2", {
                        'is-invalid': _ctx.v$.createObjective.objective.$error,
                      }]),
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.createObjective.objective) = $event)),
                                placeholder: "Objective",
                                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.createObjective.objective.$touch()))
                              }, " ", 34), [
                                [
                                  _vModelText,
                                  _ctx.createObjective.objective,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.createObjective.objective.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                    (_ctx.v$.createObjective.objective.required.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, "Required"))
                                      : (_ctx.v$.createObjective.objective.restrictCharacters1000.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Charcter Limit is exceeded"))
                                        : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _createElementVNode("div", _hoisted_22, [
                                _cache[21] || (_cache[21] = _createElementVNode("label", { class: "controllabel" }, "Location", -1)),
                                (_ctx.createObjective._id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_ctx.createObjective.entity?.label || 'N/A'), 1))
                                  : (_openBlock(), _createBlock(_component_Select, {
                                      key: 1,
                                      modelValue: _ctx.createObjective.entity,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.createObjective.entity) = $event)),
                                      options: _ctx.entitiesArray,
                                      optionLabel: "label",
                                      optionValue: "value",
                                      placeholder: "Location",
                                      class: _normalizeClass(["inputboxstyling fontSizeInpopup labelMarginTop mt-2", {
                              'is-invalid': _ctx.v$.createObjective.entity.$error,
                              'has-options': _ctx.entitiesArray && _ctx.entitiesArray.length > 0,
                              'no-options': !_ctx.entitiesArray.length &&  _ctx.searchValue !== '',
                            }]),
                                      onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getEntityTeamsList(_ctx.createObjective.entity)))
                                    }, {
                                      empty: _withCtx(() => _cache[20] || (_cache[20] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Locations Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "options", "class"])),
                                (_ctx.v$.createObjective.entity.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      (_ctx.v$.createObjective.entity.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Required"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _cache[23] || (_cache[23] = _createElementVNode("label", { class: "controllabel" }, "Departments", -1)),
                                (_ctx.createObjective._id)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.createObjective.department?.label || 'N/A'), 1))
                                  : (_openBlock(), _createBlock(_component_Select, {
                                      key: 1,
                                      modelValue: _ctx.createObjective.department,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.createObjective.department) = $event)),
                                      options: _ctx.allDeptOptions,
                                      optionLabel: "label",
                                      optionValue: "value",
                                      placeholder: "Department Name",
                                      disabled: _ctx.createObjective?.entity=='',
                                      class: _normalizeClass(["w-full custom-multiselect userSelect mt-2", {
                            'is-invalid': _ctx.v$.createObjective.department.$error,
                          }]),
                                      onSelect: _ctx.asyncFindDepartment
                                    }, {
                                      empty: _withCtx(() => _cache[22] || (_cache[22] = [
                                        _createElementVNode("span", { class: "text-xs" }, "No Departments Found", -1)
                                      ])),
                                      _: 1
                                    }, 8, ["modelValue", "options", "disabled", "class", "onSelect"])),
                                (_ctx.v$.createObjective.department.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      (_ctx.v$.createObjective.department.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_29, " Required "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                              _createElementVNode("div", _hoisted_32, [
                                _cache[24] || (_cache[24] = _createElementVNode("label", { class: "controllabel" }, "Responsibility", -1)),
                                _createVNode(_component_AutoComplete, {
                                  modelValue: _ctx.createObjective.user,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.createObjective.user) = $event)),
                                  suggestions: _ctx.userOptionsArr,
                                  onComplete: _ctx.asyncFind,
                                  optionLabel: "label",
                                  optionValue: "value",
                                  field: "label",
                                  forceSelection: false,
                                  placeholder: "Type to Search",
                                  class: _normalizeClass(["p-inputtext-sm w-full mt-2", {
                          'p-invalid': _ctx.v$.createObjective.user.$error,
                        }])
                                }, null, 8, ["modelValue", "suggestions", "onComplete", "class"]),
                                (_ctx.v$.createObjective.user.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                      (_ctx.v$.createObjective.user.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, " Required "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_35, [
                                _cache[25] || (_cache[25] = _createElementVNode("label", { class: "controllabel" }, "Date Of Target", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "date",
                                  class: _normalizeClass(["mt-2", {
                          'is-invalid':
                            _ctx.v$.createObjective.dateOfCompletion.$error,
                            'inputboxstylingForSelectAtPopup': _ctx.createObjective.dateOfCompletion == null && _ctx.createObjective.dateOfCompletion == undefined || _ctx.createObjective.dateOfCompletion=='',
                            'stylingForInputboxstylingForSelectAtPopup': _ctx.createObjective.dateOfCompletion != null && _ctx.createObjective.dateOfCompletion != undefined || _ctx.createObjective.dateOfCompletion!=''
                        }]),
                                  onFocus: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.openCalendar && _ctx.openCalendar(...args))),
                                  onkeydown: "return false",
                                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.createObjective.dateOfCompletion) = $event)),
                                  min: _ctx.getTodayDate()
                                }, null, 42, _hoisted_36), [
                                  [_vModelText, _ctx.createObjective.dateOfCompletion]
                                ]),
                                (_ctx.v$.createObjective.dateOfCompletion.$error)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                      (_ctx.v$.createObjective.dateOfCompletion.required.$invalid)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Required "))
                                        : _createCommentVNode("", true)
                                    ]))
                                  : _createCommentVNode("", true)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, [
                              _cache[26] || (_cache[26] = _createElementVNode("label", { class: "controllabel" }, "Description", -1)),
                              _withDirectives(_createElementVNode("textarea", {
                                rows: "3",
                                type: "text-area",
                                class: _normalizeClass(["inputboxstyling mt-2", {
                        'is-invalid': _ctx.v$.createObjective.description.$error,
                      }]),
                                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.createObjective.description) = $event)),
                                placeholder: "Description",
                                onInput: _cache[12] || (_cache[12] = ($event: any) => (_ctx.v$.createObjective.description.$touch()))
                              }, null, 34), [
                                [
                                  _vModelText,
                                  _ctx.createObjective.description,
                                  void 0,
                                  { trim: true }
                                ]
                              ]),
                              (_ctx.v$.createObjective.description.$error)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                                    (_ctx.v$.createObjective.description.restrictCharacters1000.$invalid)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Charcter Limit is exceeded"))
                                      : _createCommentVNode("", true)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", null, [
                _cache[27] || (_cache[27] = _createElementVNode("div", { class: "border-b border-solid border-lightgrey mx-5" }, null, -1)),
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("button", {
                    class: _normalizeClass([
                _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'
              , "mr-1.5 btnprimary"]),
                    disabled: _ctx.clickOnButton,
                    onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.onCancelbtn('cancel')))
                  }, " Reset ", 10, _hoisted_44),
                  (_ctx.createObjective._id)
                    ? (_openBlock(), _createElementBlock("button", {
                        key: 0,
                        class: _normalizeClass(_ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addOrUpdate(_ctx.createObjective)))
                      }, " Save ", 10, _hoisted_45))
                    : (_openBlock(), _createElementBlock("button", {
                        key: 1,
                        class: _normalizeClass([
                _ctx.disableStatus ? 'btnprimary' : 'btndisabled pointer-events-none'
              , "btnprimary"]),
                        disabled: _ctx.clickOnButton,
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveNewObjective()))
                      }, " Save ", 10, _hoisted_46))
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["popUp"]))
      : _createCommentVNode("", true)
  ]))
}